<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @checkbox="checkbox" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
    <UPDATE  ref="childUpdate1"  @submit="submit" :updateData="updateData1"></UPDATE>
    <UPDATE  ref="childUpdate2"  @submit="submit1" :updateData="updateData2"></UPDATE>
    <UPDATE  ref="childUpdate3"  @submit="submit" :updateData="updateData3" @uploadFile="uploadFile"></UPDATE>
    <UPDATE  ref="childUpdate4"  @submit="submit4" :updateData="updateData4" ></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import UPDATE from '@/components/page/update.vue'
  import URL from '@/views/crs/util/url'
  import DateUtil from '@/utils/IM/tradeDataUtil.js'
  import quill from "@/components/page/quill.vue"
  import Qs from 'qs'
  import axios from 'axios'

  let platformList={"Android":"Android","IOS":"IOS"};
  let simulationList={"1":"未转换","2":"有转换"};
  let realList={"9":"未转换","10":"有转换","3":"已激活","4":"未激活","5":"迷你","6":"标准","7":"金钻"};
  let AllList={"1":"未转换","2":"有转换","9":"未转换","10":"有转换","3":"已激活","4":"未激活","5":"迷你","6":"标准","7":"金钻"};
  let businessIds={};//业务id
  let language={};//语言
  let channel108={};//108
  let channel72={};//72
  let channel36={};//36
  let pushList={"1":"需第三方推送","2":"不需要第三方推送"}; //推送类型
  let messageList ={"1":"重要公告","2":"交易时间安排","3":"系统维护公告","4":"最新优惠","5":"专属回馈","6":"新闻早班车","7":"行情提醒","8":"服务提示","9":"问答快讯","10":"通知","11":"我的预警"};
  let messageList1 ={"1":"重要公告","2":"交易时间安排","3":"系统维护公告","4":"最新优惠","6":"新闻早班车","7":"行情提醒","9":"问答快讯","10":"通知","11":"我的预警"};
  let pushMode={"1":"即时","2":"定时"};//推送方式
  let pushStatus={"1":"待推送","2":"推送成功","3":"推送失败","4":"暂停推送"};//推送状态

  let syncList={"1":"官网","2":"用户中心","3":"PCUI"};//同步到
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    methods: {
      checkbox(row){
        this.deleteIds = row.map(key => key.id).join(",");
      },
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        if (clickName == "detail"){
            if(typeof row.channel =="string"){
                if(row.channel.indexOf(",")!=-1){
                    row.channel=row.channel.split(",");
                }else{
                    let channel1=[];
                    channel1.push(row.channel);
                    row.channel=channel1;
                }
            }

            if(typeof row.msgPlatform =="string"){
                if(row.msgPlatform.indexOf(",")!=-1){
                    row.msgPlatform=row.msgPlatform.split(",");
                }else{
                    let channel1=[];
                    channel1.push(row.msgPlatform);
                    row.msgPlatform=channel1;
                }
            }

            if(typeof row.targetUsers =="string"){

                if(row.targetUsers.indexOf(",")!=-1){
                    row.targetUsers=row.targetUsers.split(",");
                }else{
                    let channel1=[];
                    channel1.push(row.targetUsers);
                    row.targetUsers=channel1;
                }
            }

            if(typeof row.releaseStatus =="string"){
                if(row.releaseStatus.indexOf(",")!=-1){
                    row.releaseStatus=row.releaseStatus.split(",");
                }else{
                    let channel1=[];
                    channel1.push(row.releaseStatus);
                    row.releaseStatus=channel1;
                }
            }
            this.$refs.childUpdate.open(row);
        }
        /*else if(clickName == "delete"){
            this.$axios.get(URL.pushMsg.del+"?id="+row.id).then(res=> {
                if (res.code == 0) {
                    this.$message.success("suc");
                    this.$refs.childTable.defaultGetData(this.queryData);
                }
            });
        } */
        else if(clickName == "status"){
            this.$confirm(row.status == 1 ? window.$t("common.ifStatus"):window.$t("common.ifStatus1"), window.$t("common.tip"), {
                distinguishCancelAndClose: true,
                confirmButtonText: window.$t("common.ok"),
                cancelButtonText: window.$t("common.cancle")
            }).then(() => {
                this.$axios.get(URL.pushMsg.status+"/"+row.id+"?value="+(row.status ==1 ? 2:1)).then(res=> {
                    if (res.code == 0) {
                        this.$message.success("suc");
                        this.$refs.childTable.defaultGetData(this.queryData);
                    }
                });
            })
        }else if(clickName=="push"){
            if(typeof row.releaseStatus =="string"){
                if(row.releaseStatus.indexOf(",")!=-1){
                    row.releaseStatus=row.releaseStatus.split(",");
                }else{
                    let channel1=[];
                    channel1.push(row.releaseStatus);
                    row.releaseStatus=channel1;
                }
            }
            this.$refs.childUpdate2.open(row);
        }else if(clickName=="stop"){
            this.$confirm(row.pushStatus == 1 ? window.$t("crs.pushMsg.isStop"):window.$t("crs.pushMsg.isEnable"),  window.$t("common.tip"), {
                distinguishCancelAndClose: true,
                confirmButtonText: window.$t("common.ok"),
                cancelButtonText: window.$t("common.cancle")
            }).then(() => {
                this.$axios.get(URL.pushMsg.startOrStop+"/"+row.id+"?value="+(row.pushStatus ==4 ? 1:4)).then(res=> {
                    if (res.code == 0) {
                        this.$message.success("suc");
                        this.$refs.childTable.defaultGetData(this.queryData);
                    }
                });
            })
        }else if(clickName == "edit"){
            //修改消息中心的标题
            this.$refs.childUpdate4.open(row);
        }else if(clickName == "delete"){
            //删除消息中心的消息
            this.$axios.get(URL.pushMsg.deletMongoMsg+"?id="+row.id).then(res=> {
                if (res.code == 0) {
                    this.$message.success("suc");
                    this.$refs.childTable.defaultGetData(this.queryData);
                }
            });
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName  || window.$t("common.search") == clickName){
          this.queryData = data;
            if(data.pushTime!=undefined &&data.pushTime.indexOf(",")!=-1){
                let timeArr=data.pushTime.split(",");
                data.endTime=timeArr[1];
                data.startTime=timeArr[0];
            }
          this.$refs.childTable.defaultGetData(data);
        }else if("新增" == clickName  || window.$t("common.addNew") == clickName){
            this.updateData.submit="";
          this.$refs.childUpdate.open();
        }else if("+发布消息公告" == clickName || window.$t("crs.pushMsg.fabu") == clickName){
            this.$refs.childUpdate1.open();
        }else if("导入" == clickName || window.$t("crs.pushMsg.import") == clickName){
            this.$refs.childUpdate3.open();
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
          if(model.channel==null || model.channel==undefined || model.channel==''){
              model.channel='';
          }else if(model.channel.length>1){
              model.channel= model.channel.join(",");
          }else{
              model.channel=model.channel[0]+"";
          }

          if(model.msgPlatform==null || model.msgPlatform==undefined || model.msgPlatform==''){
              model.msgPlatform='';
          }else if(model.msgPlatform.length>1){
              model.msgPlatform= model.msgPlatform.join(",");
          }else{
              model.msgPlatform=model.msgPlatform[0]+"";
          }


          if(model.targetUsers==null || model.targetUsers==undefined || model.targetUsers==''){
              model.targetUsers='';
          }else if(model.targetUsers.length>1){
              model.targetUsers= model.targetUsers.join(",");
          }else{
              model.targetUsers=model.targetUsers[0]+"";
          }

          if(model.releaseStatus==null || model.releaseStatus==undefined || model.releaseStatus==''){
              model.releaseStatus='';
          }else if(model.releaseStatus.length>1){
              model.releaseStatus= model.releaseStatus.join(",");
          }else{
              model.releaseStatus=model.releaseStatus[0]+"";
          }
         /* if(model.id==undefined || model.id ==null || model.id == ''){
              model.users=this.user;
          }*/
        //根据是否包含id更新还是添加
          this.$refs.childUpdate.loading();
          this.$refs.childUpdate1.loading();
          this.$refs.childUpdate3.loading();
        this.dataChanage((model.id!=undefined && model.id!=null && model.id!='') ? URL.pushMsg.edit:URL.pushMsg.save,model,res => {
          if (res.code == 0){
          this.$refs.childUpdate.close();
          this.$refs.childUpdate1.close();
          this.$refs.childUpdate3.close();
          this.$message.success("suc");
           this.$refs.childTable.defaultGetData(this.queryData);
        }else{

        }
      })
      },
      submit1(model){
          if(model.releaseStatus==null || model.releaseStatus==undefined || model.releaseStatus==''){
              model.releaseStatus='';
          }else if(model.releaseStatus.length>1){
              model.releaseStatus= model.releaseStatus.join(",");
          }else{
              model.releaseStatus=model.releaseStatus[0]+"";
          }
          //根据是否包含id更新还是添加
          this.$refs.childUpdate2.loading();
          this.dataChanage(URL.pushMsg.push,model,res => {
              if (res.code == 0){
                  this.$refs.childUpdate2.close();
                  this.$message.success("suc");
                  this.$refs.childTable.defaultGetData(this.queryData);
              }else{

              }
          })
      },
      submit4(model){
          this.$refs.childUpdate4.loading();
          //根据是否包含id更新还是添加
          this.dataChanage(URL.pushMsg.editMongoMsg,model,res => {
              if (res.code == 0){
                  this.$refs.childUpdate4.close();
                  this.$message.success("suc");
                  this.$refs.childTable.defaultGetData(this.queryData);
              }else{
                  this.$message.error("fail");
              }
          })
      },
      dataChanage(url,option,suc,fail){
        this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if(suc && (typeof suc == 'function')) suc(res);
      }).catch(res => {
          if(fail && (typeof fail == 'function')) fail(res);
      })
      }, uploadFile(col,res){
            this.$set(col,"data",(res || []).join(","));
            //col.data = (res || []).join(",");
            //this.user = res.join(",");
        }
    },
    data () {
      return {
        deleteIds:"",
        user:"",
        queryData:{},
        /*新增或更新*/
        updateData:{
            submit:"hidden",
          cols:[

          ]
        },
        updateData1:{cols:[]},
        updateData2:{cols:[
                {title:'id',field:'id',hidden:true},
                { title: window.$t("crs.pushMsg.releaseStatus"), field: 'releaseStatus',type:4,hasCheckAll:true,checkAll:false,data:[],optionList:syncList}
            ]},
        updateData3:{cols:[]},
        updateData4:{cols:[
                {title:'id',field:'id',hidden:true},
                { title: window.$t("crs.pushMsg.msgTitle"), field: 'msgTitle',required:true},
                { title: window.$t("crs.pushMsg.msgContent"), field: 'msgContent',type:14},
         ]},
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
                          { title: window.$t("crs.pushMsg.msgTitle"), field: 'msgTitle'},
                          { title: window.$t("crs.pushMsg.business"), field: 'businessId',type:2},
                          { title: window.$t("crs.pushMsg.releaseStatus"), field: 'releaseStatus',type:2,optionList:{"Android":"Android","IOS":"IOS","1":"官网","2":"用户中心","3":"PCUI"}},
                          { title: window.$t("crs.pushMsg.msgLanguage"), field: 'msgLanguage',type:2,optionList:{"zh_CN":"zh_CN","en_US":"en_US","vi_VN":"vi_VN"}},
                          { title: window.$t("crs.pushMsg.pushStatus"), field: 'pushStatus',type:2,optionList:{"1":"待推送","2":"推送成功","3":"推送失败","4":"暂停推送"}},
                          { title: window.$t("crs.pushMsg.pushTime"), field: 'pushTime',type:6,noTable:true},
                          {click:window.$t("common.search"),auth:"sys:pushMsg:find"},
                          {click:window.$t("common.addNew"),auth:"sys:pushMsg:save"},
                          {click:window.$t("common.import"),auth:"sys:pushMsg:save"}
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: URL.pushMsg.query, //请求路径和参数
          selection: true,
          sequence: true,
          cols: [
                          { title: window.$t("crs.pushMsg.pushConfig"), field: 'pushConfig',render:(data)=>{
                              return pushList[data];
                              }},
                          { title: window.$t("crs.pushMsg.pushTime"), field: 'pushTime',render:(data,full)=>{
                             return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                          }},
                          { title: window.$t("crs.pushMsg.type"), field: 'type',render:(data)=>{
                              return messageList[data];
                          }},
                          { title: window.$t("crs.pushMsg.pushStatus"), field: 'pushStatus',render:(data)=>{
                              return pushStatus[data];
                              }},
                          { title: window.$t("crs.pushMsg.msgTitle"), field: 'msgTitle'},
                          { title: window.$t("crs.pushMsg.msgPlatform"), field: 'msgPlatform'},
                          { title: window.$t("crs.pushMsg.channel"), field: 'channel'},
                          { title: window.$t("crs.pushMsg.targetUsers"), field: 'targetUsers',render:(data)=>{
                              let resultStr="";
                              let prefixStr="";
                               if(data!=null && data.indexOf(",") !=-1){
                                 let dataArr=data.split(",");
                                   for (let i in dataArr){
                                       prefixStr="真实"
                                       if(dataArr[i]=="1" || dataArr[i]=="2"){
                                           prefixStr="模拟";
                                       }
                                       if(dataArr[i]=="0"){
                                           resultStr=resultStr + "所有用户,";
                                       }else{
                                       resultStr= resultStr + prefixStr+AllList[dataArr[i]]+",";
                                       }
                                   }
                                   return  resultStr.substring(0,resultStr.lastIndexOf(","));
                               }else if(data !=undefined && data !="" && data!=null){
                                   prefixStr="真实"
                                   if(data=="1" || data=="2"){
                                       prefixStr="模拟";
                                   }
                                   if(data =="0"){
                                       return "所有用户";
                                   }
                               return prefixStr + AllList[data];
                               }
                               return "";
                          }},
                          { title:  window.$t("crs.pushMsg.users"), field: 'users'},
                          { title: window.$t("crs.pushMsg.msgLanguage"), field: 'msgLanguage'},
                          { title: window.$t("crs.pushMsg.platform"), field: 'releaseStatus',render:(data)=>{
                              if(data.indexOf(",")!=-1){
                                  let str="";
                                  let dataArr=data.split(",");
                                 for(let i in dataArr){
                                     if(dataArr[i] == "0"){
                                         str=str+"APP端,";
                                     }else if(dataArr[i] != ""){
                                         str=str+syncList[dataArr[i]]+",";
                                     }
                                 }
                                 return str.substring(0,str.lastIndexOf(","));
                              }else{
                                  if(data =="0"){
                                   return "APP端";
                                  }
                                  return syncList[data];
                              }
                              }},
                          { title:  window.$t("crs.pushMsg.businessId"), field: 'businessId'},
                          { title:  window.$t("crs.pushMsg.status"), field: 'status',render:(data)=>{
                                  return data==1 ? window.$t("common.start"):window.$t("common.stop");
                              }},
                          { title: window.$t("crs.pushMsg.remark"), field: 'remark'},
                          { title: window.$t("crs.pushMsg.createBy"), field: 'createByName'},
                          { title: window.$t("crs.pushMsg.fabuDate"), field: 'createDate'},
                          //{ title: window.$t("crs.pushMsg.createBy"), field: 'createBy'},
              {title:window.$t("common.handle"),width:'350px',btnClick:[
                      // {name:(data,full)=>{
                      //         return full.status ==1 ? "禁用":"启用" ;
                      //     },click:"status",type:"primary",icon:(data,full)=>{
                      //      return full.status== 1 ? "el-icon-star-on":"el-icon-star-off";
                      //     },auth:"sys:pushMsg:status" },
                      {name:(data,full)=>{
                          return full.pushStatus ==4 ? window.$t("common.start"):window.$t("common.stop");
                          },click:"stop",type:"primary",icon:(data,full)=>{
                             return full.pushStatus == 1 ? "el-icon-message-solid":"el-icon-bell";
                          },hidden:(data,col)=>{
                          if(((col.pushStatus ==1 || col.pushStatus ==4) && col.pushTime > Date.parse(new Date()))){
                              return false;
                          }
                          return true;
                      }},
                      {name:window.$t("common.detail"),click:"detail",type:"primary",icon: "el-icon-edit",auth:"sys:pushMsg:edit"},
                      {name:window.$t("crs.pushMsg.push"),click:"push",type:"primary",icon: "el-icon-upload2",auth:"sys:pushMsg:push"},
                      {name:window.$t("crs.bt.edit"),click:"edit",type:"primary",icon: "el-icon-edit"},
                      {name:window.$t("crs.bt.delete"),click:"delete",type:"primary",icon: "el-icon-delete"}
                      ]},
          ]
        }
      }
    } ,
      created(){
          this.$axios.get(URL.pushMsg.getData).then(res=> {
              if (res.code == 0) {
                  language=res.result.language;
                  businessIds=res.result.businessIds;
                  channel108=res.result.channel108;
                  channel72=res.result.channel72;
                  channel36=res.result.channel36;
                  this.formData. cols=[
                      { title: window.$t("crs.pushMsg.msgTitle"), field: 'msgTitle'},
                      { title: window.$t("crs.pushMsg.business"), field: 'businessId',type:2,optionList:businessIds},
                      { title: window.$t("crs.pushMsg.releaseStatus"), field: 'releaseStatus',type:2,optionList:{"Android":"Android","IOS":"IOS","1":"官网","2":"用户中心","3":"PCUI"}},
                      { title: window.$t("crs.pushMsg.msgLanguage"), field: 'msgLanguage',type:2,optionList:{"zh_CN":"zh_CN","en_US":"en_US","vi_VN":"vi_VN"}},
                      { title: window.$t("crs.pushMsg.pushStatus"), field: 'pushStatus',type:2,optionList:{"1":"待推送","2":"推送成功","3":"推送失败","4":"暂停推送"}},
                      { title: window.$t("crs.pushMsg.pushTime"), field: 'pushTime',type:6,noTable:true},
                      {click:window.$t("common.search"),auth:"sys:pushMsg:find"},
                      {click:window.$t("common.addNew"),auth:"sys:pushMsg:save"},
                      {click:window.$t("common.import"),auth:"sys:pushMsg:save"}
                  ]
                  this.updateData.cols=[
                      {title:'id',field:'id',hidden:true},
                      {title:window.$t("crs.pushMsg.targetUsers"),field:"targetUsers",type: 8,selectList:[
                              {checkAllName:"全部",optionList:{"0":"全部"},check:"k0"},
                              {checkAllName:"模拟",optionList:simulationList,check:"k1"},
                              {checkAllName:"真实",optionList:realList,check:"k2"}
                          ],data:[],hidden:(model,col)=>{return (model.users!=""&&model.users!=undefined&&model.users!=null);},required:true},
                      { title: window.$t("crs.pushMsg.users"), field: 'users',readonly:true,hidden:(model,col)=>{return model.users==""||model.users==undefined||model.users==null}},
                      { title: window.$t("crs.pushMsg.platform"), field: 'msgPlatform',type:4,required:true,hasCheckAll:true,checkAll:false,data:[],optionList:platformList},
                      { title: window.$t("crs.pushMsg.businessId"), field: 'businessId',type:3,optionList:businessIds,data:"108",required:true},
                      { title: window.$t("crs.pushMsg.msgLanguage"), field: 'msgLanguage',type:3,optionList:language,data:"zh_CN",required:true},
                      { title: window.$t("crs.pushMsg.pushConfig"), field: 'pushConfig',type:3,optionList:pushList,data:"1",required:true},
                      { title: window.$t("crs.pushMsg.channel"), field: 'channel',type: 8,selectList:[
                              {checkAllName:"108",optionList:channel108,check:"y0"},
                              // {checkAllName:"72",optionList:channel72,check:"y1"},
                              // {checkAllName:"36",optionList:channel36,check:"y2"}
                          ],data:[],required:true},
                      { title: window.$t("crs.pushMsg.push"), field: 'type',type:2,required:true,data:[],isNumber:true,optionListObjRender:(model,col)=>{
                            if(model.targetUsers!=undefined && model.targetUsers!=null && model.channel!=undefined && model.channel!=null) {
                                if (model.targetUsers.indexOf("0") != -1 && model.channel.indexOf("VN_UAT") != -1) {
                                    return messageList1;                                }
                                return messageList;
                            }
                          }},
                      { title: window.$t("crs.pushMsg.pushMode"), field: 'pushMode',type:3,optionList:pushMode,data:1,isNumber:true,required:true},
                      { title: window.$t("crs.pushMsg.pushTime"), field: 'pushTime',type:5,hidden:(model,col)=>{return model.pushMode == "1";},required:(model,col)=>{
                              return model.pushMode == "2";
                          }},
                      { title: window.$t("crs.pushMsg.msgTitle"), field: 'msgTitle',required:true},
                      { title: window.$t("crs.pushMsg.msgRemark"), field: 'msgRemark',textType:"textarea"},
                      { title: window.$t("crs.pushMsg.msgContent"), field: 'msgContent',type:14},
                      { title: window.$t("crs.pushMsg.releaseStatus"), field: 'releaseStatus',type:4,hasCheckAll:true,checkAll:false,data:[],optionList:syncList}
                  ]
                  this.updateData1.cols=[
                      {title:'id',field:'id',hidden:true},
                      { title: window.$t("crs.pushMsg.businessId"), field: 'businessId',type:3,optionList:businessIds,data:"72",required:true},
                      { title: window.$t("crs.pushMsg.msgLanguage"), field: 'msgLanguage',type:3,optionList:language,data:"zh_CN",required:true},
                      { title: window.$t("crs.pushMsg.type"), field: 'type',type:2,required:true,optionList:messageList,data:[],isNumber:true},
                      { title: window.$t("crs.pushMsg.pushMode"), field: 'pushMode',type:3,optionList:pushMode,data:1,isNumber:true,required:true},
                      { title: window.$t("crs.pushMsg.pushTime"), field: 'pushTime',type:5,hidden:(model,col)=>{return model.pushMode == "1";},required:(model,col)=>{
                              return model.pushMode == "2";
                          }},
                      { title: window.$t("crs.pushMsg.msgTitle"), field: 'msgTitle',required:true},
                      { title: window.$t("crs.pushMsg.msgRemark"), field: 'msgRemark',textType:"textarea"},
                      { title: window.$t("crs.pushMsg.msgContent"), field: 'msgContent',type:14},
                      { title: window.$t("crs.pushMsg.fabudao"), field: 'releaseStatus',type:4,hasCheckAll:true,checkAll:false,data:[],optionList:syncList}
                  ]

                  this.updateData3.cols=[
                      {title:'id',field:'id',hidden:true},
                      { title: window.$t("common.import"), field: 'users',type:11,action:URL.pushMsg.uploadTemplate,downUrl:"https://static.chwenda.com/source/downloadModel/消息推送用户模板.xlsx"},
                      { title: window.$t("crs.pushMsg.msgPlatform"), field: 'msgPlatform',type:4,required:true,hasCheckAll:true,checkAll:false,data:[],optionList:platformList},
                      { title: window.$t("crs.pushMsg.businessId"), field: 'businessId',type:3,optionList:businessIds,data:"108",required:true},
                      { title: window.$t("crs.pushMsg.msgLanguage"), field: 'msgLanguage',type:3,optionList:language,data:"zh_CN",required:true},
                      { title: window.$t("crs.pushMsg.pushConfig"), field: 'pushConfig',type:3,optionList:pushList,data:"1",required:true},
                      { title: window.$t("crs.pushMsg.channel"), field: 'channel',type: 8,selectList:[
                              {checkAllName:"108",optionList:channel108,check:"y0"},
                              // {checkAllName:"72",optionList:channel72,check:"y1"},
                              // {checkAllName:"36",optionList:channel36,check:"y2"}
                          ],data:[],required:true},
                      { title: window.$t("crs.pushMsg.type"), field: 'type',type:2,required:true,optionList:messageList,data:[],isNumber:true},
                      { title: window.$t("crs.pushMsg.pushMode"), field: 'pushMode',type:3,optionList:pushMode,data:1,isNumber:true,required:true},
                      { title: window.$t("crs.pushMsg.pushTime"), field: 'pushTime',type:5,hidden:(model,col)=>{return model.pushMode == "1";},required:(model,col)=>{
                              return model.pushMode == "2";
                          }},
                      { title: window.$t("crs.pushMsg.msgTitle"), field: 'msgTitle',required:true},
                      { title: window.$t("crs.pushMsg.msgRemark"), field: 'msgRemark',textType:"textarea"},
                      { title: window.$t("crs.pushMsg.msgContent"), field: 'msgContent',type:14},
                      { title: window.$t("crs.pushMsg.push"), field: 'releaseStatus',type:4,hasCheckAll:true,checkAll:false,data:[],optionList:syncList}
                  ]
              }
          });
      }
  }
</script>
